
import { defineComponent, onMounted, watch, computed, PropType } from "vue";
import SelectInput from "./SelectInput.vue";
import store from "@/store";

export default defineComponent({
  name: "InputArray",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    tclass: {
      type: String,
      required: false,
    },
    arrayName: {
      type: String,
      required: true,
    },
    excludeItem: {
      type: Number,
      required: false,
    },
    excludeItens: {
      type: Array as PropType<number[]>,
      required: false,
    },
  },
  setup(props) {
    const items = computed(() => {
      let array = store.state.arr[props.arrayName]?.valores;

      if (!array) {
        return [];
      }

      if (props.excludeItem && props.excludeItem > 0) {
        array = array.filter((i) => i.value != props.excludeItem);
      }

      if (props.excludeItens) {
        for (const item of props.excludeItens) {
          array = array.filter((i) => i.value != item);
        }
      }

      return [
        {
          name: "Selecione...",
          value: "",
        },
        ...array,
      ];
    });

    watch(
      () => props.arrayName,
      () => {
        store.dispatch("getArray", props.arrayName);
      }
    );
    onMounted(() => {
      store.dispatch("getArray", props.arrayName);
    });

    return {
      items,
    };
  },
  components: { SelectInput },
});
